import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import AuthImage from '../../../assets/img/auth/auth_illustration.svg';
import RoutalLogo from '../../../assets/img/logo-routal.svg';
import { Text } from '../../../react-components/Text';

export const AuthBackground = () => {
  return (
    <Grid
      style={{
        height: `100%`,
        width: `100%`,
        position: `relative`,
        background: `linear-gradient(180deg, ${RoutalPalette.primary60} 0%, ${RoutalPalette.primary40n} 50%)`,
      }}
    >
      <Grid
        position="absolute"
        style={{
          position: `absolute`,
          inset: 0,
          bottom: `50%`,
          backgroundImage: `url(${AuthImage})`,
          backgroundRepeat: `no-repeat`,
          backgroundPosition: `center bottom`,
        }}
      />
      <Grid position="absolute" top="8%" left="0" right="0" display="flex" alignItems="center" flexDirection="column">
        <img src={RoutalLogo} alt="routal-logo" style={{ height: `100%`, objectFit: `cover` }} />
        <VSpacer small />
        <Text variant="h6" isBold style={{ color: RoutalPalette.neutral02n }}>
          Drivers
        </Text>
      </Grid>
    </Grid>
  );
};
